// Content for Japanese locale

// App Configuration
export const appConfig = {
  liffUrl: 'https://miniapp.line.me/2009469802-yIbZktqb',
};

export const content = {
  header: {
    logo: 'とりアイコ',
    nav: {
      features: 'できること',
      howTo: '使い方',
      faq: 'よくある質問',
    },
  },
  hero: {
    title: '友達のアイコンを集めよう！',
    tagline:
      'とりあえず、アイコン帳。友達と実際に会ったときにQRコードをスキャンして、アイコンをコレクションする楽しさ。',
    warning:
      '⚠️ 重要：このアプリはLINEアプリ内でのみ動作します。外部ブラウザでは一部機能が利用できません。',
    cta: {
      primary: '🚀 「とりアイコ」をLINEで開く',
      secondary: '📖 使い方を見る',
    },
  },
  features: {
    title: 'できること',
    items: [
      {
        emoji: '💮',
        title: 'アイコンを集める',
        description:
          'QRコードをスキャンして、友達のアイコンを集めます。カレンダーで誰といつ会ったかが一目でわかります。',
      },
      {
        emoji: '📅',
        title: 'カレンダーで振り返り',
        description:
          '月間カレンダーで友達と会った日を確認。日付をタップすると、その日に会った友達のアイコンが見られます。',
      },
      {
        emoji: '📖',
        title: 'アイコン帳',
        description:
          '集めたアイコンをアイコン帳風の3×3グリッドで表示。コレクションが増えていく楽しさを味わえます。',
      },
      {
        emoji: '👥',
        title: '友達を招待',
        description:
          '招待リンクで友達を招待。友達リストで承認済みの友達と、承認待ちのリクエストを確認できます。',
      },
    ],
  },
  howTo: {
    title: '使い方',
    steps: [
      {
        title: '「とりアイコ」をLINEで開く',
        description: 'LINEアプリからとりアイコを開きます',
      },
      {
        title: '友達を招待',
        description: '招待リンクを送って友達を招待します',
        shareButton: true,
      },
      {
        title: 'QRコードをスキャン',
        description: '友達と会ったらQRコードをスキャンします',
      },
      {
        title: 'アイコンゲット',
        description: 'アイコンを集めてカレンダーに記録されます',
      },
      {
        title: 'アイコン帳を確認',
        description: '集めたアイコンをカレンダーで確認します',
      },
    ],
  },
  faq: {
    title: 'よくある質問',
    items: [
      {
        question: 'とりアイコって何ですか？',
        answer:
          '友達と実際に会った記録をアイコンで集めるLINEミニアプリです。QRコードをスキャンして、友達との思い出を楽しく記録できます。',
      },
      {
        question: 'どうやって使うの？',
        answer:
          'LINEアプリから開いて、友達を招待します。友達と会ったときにQRコードをスキャンすると、アイコンが記録されます。',
      },
      {
        question: 'アイコンはどうやって集めるの？',
        answer:
          '友達のQRコードをスキャンするか、友達にあなたのQRコードをスキャンしてもらうことでアイコンを集められます。',
      },
      {
        question: '友達を招待するには？',
        answer:
          'アプリ内の招待リンクをLINEで送信します。友達がリンクをタップしてアプリを開くと、友達リクエストが送信されます。',
      },
    ],
  },
  slideshow: {
    title: '画面プレビュー',
    slides: [
      {
        title: 'カレンダー画面',
        description: '友達と会った日付をカレンダーで確認できます',
      },
      {
        title: 'アイコンコレクション画面',
        description: '収集したアイコンを一覧で確認できます',
      },
    ],
  },
  tips: {
    title: 'ヒント',
    items: [
      {
        title: '毎日チェック',
        description: 'カレンダーを毎日チェックして、友達との思い出を振り返りましょう。',
      },
      {
        title: '友達を増やそう',
        description: 'たくさんの友達を招待して、アイコンコレクションを充実させましょう。',
      },
      {
        title: 'カレンダーで振り返り',
        description: 'カレンダーを見て、誰といつ会ったか振り返ろう。思い出がいっぱい。',
      },
    ],
  },
  roadmap: {
    title: '今後の予定',
    items: [
      'アイコン獲得時の通知機能',
      'アイコンの統計グラフ',
      'バッジ・実績システム',
      '友達との思い出メモ機能',
    ],
  },
  footer: {
    links: {
      contact: 'お問い合わせ',
      privacy: 'プライバシーポリシー',
      terms: '利用規約',
    },
    copyright: '© 2026 とりアイコ. All rights reserved.',
  },
};

export type Content = typeof content;
